import { RoleType } from "@/types/users";

export const ACCOUNT_ROLE_TYPES = [
  { label: "受講者", value: String(RoleType.USER) },
  { label: "事業所管理者", value: String(RoleType.MEMBER) },
  { label: "法人管理者", value: String(RoleType.ADMIN) },
  { label: "オーナー", value: String(RoleType.OWNER) },
];
